module.exports = __webpack_public_path__ + "media/bootstrap-icons/chevron-compact-right-fa0a571c.svg";